cb.define(function() {
  var AA_aa_userlist_VM_Extend = {
    doAction: function(name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function(viewmodel) {
      //隐藏新增按钮
      // var btnAdd = viewmodel.get("btnAdd");
      // btnAdd.setVisible(false);
      // let gridModel = viewmodel.getGridModel();
      // // 设置SKU表格按钮状态
      // gridModel.on('beforeSetActionsState', (args) => {
      //   args.length && args.map((val) => {
      //     val.btnDelete.visible = false;
      //     return val;
      //   });
      // });

      viewmodel.getGridModel().on('beforeLoad', function(data) {
        if (data.condition) {
          //管理员不能被从列表操作
          data.condition['isExtend'] = true;
          data.condition['simpleVOs'] = [];
          var simpleVOs = data.condition.simpleVOs;
          var defwhere = {};
          defwhere['field'] = 'userType';
          defwhere['value1'] = 0;
          defwhere['op'] = 'neq';
          simpleVOs.push(defwhere);
          defwhere = {};
          defwhere['field'] = 'id';
          defwhere['value1'] = cb.rest.AppContext.user.id;
          defwhere['op'] = 'neq';
          simpleVOs.push(defwhere);
          defwhere = {};
          defwhere['field'] = 'userType';
          defwhere['value1'] = -1;
          defwhere['op'] = 'neq';
          simpleVOs.push(defwhere);
        }

      });
      viewmodel.on("beforeAdd", function () {
        console.log(cb.rest.AppContext.user.customer);
        console.log(cb.rest.AppContext.user);
        //当前登录用户的用户类型 lcccc
        let userType = cb.rest.AppContext.user.userType;
        console.log(userType);
        if (userType == 4 || userType == 5) {
          //获取该租户是否开通U订货  同步
          let proxy = cb.rest.DynamicProxy.create({
            _label: {
              url: '/bill/addUserBeforeCheck',
              method: 'POST',
              options: {async: false}
            }
          });
          let params = {billnum: "aa_userlist"};
          //返回的参数 map
          let result = proxy._label(params);
          // if (err) {
          //   cb.utils.alert(err.message, 'error');
          //   return false;
          // }
          //已开通订货
          // if (result.isOpenUdh != '0') {
          //
          // }
          //已开通友零售
          if (result.isOpenURetail != '0') {
            //1-U订货，2-基础服务
            let docSource = result.docSource;
            if (docSource != '2') {
              cb.utils.alert('请到【订货中心】增加客户子账号！！！', 'warning');
              return false;
            }
          } else {
            cb.utils.alert('请到【订货中心】增加客户子账号！！！', 'warning');
            return false;
          }
        }

        // if (cb.rest.AppContext.user.customer) {
        //   cb.utils.alert('请到【订货中心】增加客户子账号', 'warning');
        //   return false;
        // }
      });
      viewmodel.on('reset', function(args) {
        cb.utils.confirm("是否确认重置此用户登录密码", function() {
          var proxy = cb.rest.DynamicProxy.create({
            ensure: {
              url: args.cSvcUrl,
              method: args.cHttpMethod
            }
          });
          var params = {id:viewmodel.getGridModel().getRow(args.params.index).id};
          proxy.ensure(params, function(err, result) {
            if(err) {
              cb.utils.alert(err.message, 'error');
              return;
            }
            if(result) {
              cb.utils.alert('操作成功', 'success');
            }
          });
        });
      });

      viewmodel.on('unlock', function(args) {
        var proxy = cb.rest.DynamicProxy.create({
          ensure: {
            url: args.cSvcUrl,
            method: args.cHttpMethod
          }
        });
        var params = {id:viewmodel.getGridModel().getRow(args.params.index).id};
        proxy.ensure(params, function(err, result) {
          if(err) {
            cb.utils.alert(err.message, 'error');
            return;
          }
          cb.utils.alert('操作成功', 'success');
        });
      })
      
    }
  };

  try {
    module.exports = AA_aa_userlist_VM_Extend;
  } catch (error) {

  }
  return AA_aa_userlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_userlist_VM.Extend.js